import { GlobalState } from '@leverege/ui-redux'

/**
 * 
 * @param {String} type The type of plugin being mutated
 * @param {Object} plugin The plugin
 * @param {Molten} molten the molten instance
 * @returns 
 */
export default function DefaultMutator( type, plugin, molten ) {
  const { id } = plugin
  if ( id != null ) {
    const mutate = molten.getConfig( 'mutations' )?.[id] 
    if ( mutate ) {

      if ( typeof mutate === 'function' ) {
        return mutate( type, plugin, molten )
      } 

      let p = plugin
      if ( mutate.usedByRoles ) {
        p = installHandles( p, mutate.usedByRoles, true )
      }
      if ( mutate.excludedFromRoles ) {
        p = installHandles( p, mutate.excludedFromRoles, false )
      }
      if ( mutate.properties && typeof mutate.properties === 'object' ) {
        p = Object.assign( Object.create( Object.getPrototypeOf( plugin ) ), plugin, mutate.properties )
      }
      return p
    }
  }
  return plugin
}

function installHandles( plugin, roles, isIncludes = true ) {

  if ( plugin.handles == null ) {
    console.warn( `${plugin.id} has a handles mutation but does not have a handles` )
  }

  const arr = typeof roles === 'string' ? [ roles ] : Array.isArray( roles ) ? roles : null

  if ( arr == null ) {
    return plugin
  }

  const p = Object.assign( Object.create( Object.getPrototypeOf( plugin ) ), plugin )
  if ( isIncludes ) {
    p.handles = ( context ) => {
      const activeRoleName = GlobalState.get()?.ui?.activePersona?.name
      return roles.includes( activeRoleName ) && ( plugin.handles == null || plugin.handles( context ) )
    }
  } else {
    p.handles = ( context ) => {
      const activeRoleName = GlobalState.get()?.ui?.activePersona?.name
      return !roles.includes( activeRoleName ) && ( plugin.handles == null || plugin.handles( context ) )
    }
  }
  return p
}
